<template>
    <textarea
        v-model="input"
        class="shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border border-gray-300 rounded-md"
        style="min-height: 56px; resize: none; field-sizing: content"
    ></textarea>
</template>

<script setup>
const input = defineModel();

defineOptions({
    name: 'FormTextarea',
});
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;
    background: transparent; /* make scrollbar transparent */
}
</style>
